export const SET_PARAM_VALUES_TARGET = '/api/param_values/set'
